import { ProductCardList } from "./ProductCardList";
import { useInstantSearch } from "react-instantsearch";

export const FiltersContainer = () => {
  const { scopedResults } = useInstantSearch();
  const hits = scopedResults?.[0]?.results?.hits ?? [];

  return (
    <div className="p-0">
      <div className="gap-4 p-0">
        <ProductCardList cards={hits} />
      </div>
    </div>
  );
};
